export * from './Detail';
export * from './ResourceAttribute';
